import React from 'react';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Header.css';

const Header = () => {
  const { business } = useAuth();

  return (
    <div className="header">
      <h1>Business Panel</h1>
      <div className="header-right">
        <span>{business?.email}</span>
      </div>
    </div>
  );
};

export default Header;